import { render, staticRenderFns } from "./outright.vue?vue&type=template&id=5879e81a&"
import script from "./outright.vue?vue&type=script&lang=js&"
export * from "./outright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BetBtn: require('/var/web/bet777.es/components/bet_btn.vue').default})
